// TODO: Understand why those window[...] calls are erroring out with: TS7015: Element implicitly has an 'any' type because index expression is not of type 'number'.

interface LinkReplacerCommand {
    selector: string
    newWindow?: boolean
}

export const linkreplacer = {
    replaceLinks: (element: Element, newWindow = false): void => {
        let text = element.innerHTML
        const matches = text.matchAll(/\{link_([^}]+)}/gi)
        for (const match of matches) {
            const key = match[1]
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (window['page_' + key]) {
                const link = document.createElement('a')
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                link.href = window['page_' + key]
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                link.innerText = window['page_' + key + '_title'] || window['page_' + key]
                if (newWindow) {
                    link.target = '_blank'
                }
                text = text.replace(match[0], link.outerHTML)
            }
        }
        element.innerHTML = text
    },
    init: (commands: LinkReplacerCommand[]): void => {
        if (Array.isArray(commands)) {
            commands.forEach((command) => {
                const elements = document.querySelectorAll(command.selector);
                elements.forEach((element) => {
                    linkreplacer.replaceLinks(element, command.newWindow)
                });
            });
        }
    }
}
